module.exports = "<div class=\"assign-vhcle-popup-wrapper\">\n\n  <lfwms-result-data-table \n  (buttonActionHandler)=\"handleButtonAction($event)\" \n [tableMode] = \"tableMode\"\n[searchService]=\"assignVehicleSearchService\">\n</lfwms-result-data-table>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.html
// module id = ../../../../../src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.html
// module chunks = main